// Sesgo de la biblioteca de ejercicios por disciplina (heurístico, sin tags
// en los ejercicios): derivamos relevancia de category + equipment existentes.

import type { Discipline, Exercise, ExerciseCategory, Equipment } from '../types';

interface Hint {
  categories?: ExerciseCategory[];
  equipment?: Equipment[];
}

const HINTS: Partial<Record<Discipline, Hint>> = {
  bodybuilding: { categories: ['compound', 'basic', 'isolation'] }, // todo salvo cardio
  powerlifting: { categories: ['compound', 'basic'], equipment: ['barbell'] },
  weightlifting: { categories: ['compound', 'basic'], equipment: ['barbell'] },
  crossfit: { categories: ['compound', 'cardio'], equipment: ['barbell', 'bodyweight', 'dumbbell'] },
  cardio: { categories: ['cardio'] },
  calisthenics: { equipment: ['bodyweight'] },
  // hybrid / general → sin sesgo (se muestran todos)
};

/** ¿Tiene esta disciplina un sesgo de ejercicios definido? */
export function disciplineHasHint(discipline?: Discipline | null): boolean {
  return !!(discipline && HINTS[discipline]);
}

/** ¿El ejercicio encaja con la disciplina? (AND de las dimensiones presentes en el hint) */
export function isRecommendedExercise(
  discipline: Discipline | null | undefined,
  ex: Pick<Exercise, 'category' | 'equipment'>
): boolean {
  if (!discipline) return true;
  const h = HINTS[discipline];
  if (!h) return true;
  if (h.categories && !h.categories.includes(ex.category)) return false;
  if (h.equipment && (!ex.equipment || !h.equipment.includes(ex.equipment))) return false;
  return true;
}
